import { styled } from '@material-ui/core'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

export default AccordionDetails
